/* eslint-disable */
import React from "react";

import { Box, Grid, Typography } from "@mui/material";
import {
  LocationOn as LocationOnIcon,
  QueryBuilder as QueryBuilderIcon,
  Launch as LaunchIcon,
  LocalPhone as LocalPhoneIcon,
  ErrorOutline as ErrorOutlineIcon,
  LocalOfferOutlined as LocalOfferOutlinedIcon,
  SellOutlined as SellOutlinedIcon,
} from "@mui/icons-material";

import { useTranslation } from "react-i18next";

import {
  OrderProps,
  OrderUpdateActions,
} from "store/modules/Orders/types.store";

import { formatByText, formatProductNameAndDescription, formatPlacedOrigin } from "utils";
import { formatStreetAddress } from "utils/formatByText";

import * as Styled from "./styles";
import { useNavigate } from "react-router-dom";
import { useOrders } from "pages/ManageOrders/useOrders";
import {
  copyDivToClipboard,
  formatPhoneByText,
  totalPrices,
  voucherFunction,
} from "utils/formatByText";
import { EOrderStatusFinally, EStatusPayments } from "enums/options/orders";
import { toast } from "react-toastify";
import DivCopyComponent from "./divCopyComponent";
import TimeLine from "./TimeLine";
import OrderDriverSection from "./OrderDriverSection";
import {
  formatDateToDDMMYYYY,
  formatDateToHHMM,
  getSchedulingDayLabel,
  formatTimeLocal,
} from "utils/dateUtils";
import { addHours } from "date-fns";
import { orderHasGasDoPovoItems } from "utils/gasDoPovo";

interface CardActionsProps {
  data: OrderProps;
  handleOrderUpdate?: (
    type: OrderUpdateActions,
    id: string,
    dealerId: string,
    paymentType: string,
    valeGas: boolean,
  ) => void;
  currentTab?: string;
  fullHeight?: boolean;
  openModalCode: () => void;
}

const CardOrderDetails = ({
  data,
  handleOrderUpdate,
  openModalCode,
  currentTab,
  fullHeight,
}: CardActionsProps): JSX.Element => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { typeOrders } = useOrders();
  const showGasDoPovoFlag = orderHasGasDoPovoItems(data?.items);

  const enabledPin = process.env.REACT_APP_ENABLE_PIN_ORDER;
  const scheduledOrder = data?.scheduling?.enabled;
  const scheduledOrderDate = data?.scheduling?.startAt;

  const typesOfCompletedOrders = [
    EOrderStatusFinally.TIMEOUTCANCELLED,
    EOrderStatusFinally.CONSUMERCANCELLED,
    EOrderStatusFinally.DEALERCANCELLED,
    EOrderStatusFinally.DELIVERED,
  ];

  const timeLineFunction = (data: OrderProps) => {
    const timeLineFinalized = data?.timeline?.find((data) =>
      typesOfCompletedOrders?.find((status) => status === data?.description),
    );

    if (timeLineFinalized && currentTab === "3") {
      return data?.createdAt
        ? ` ${formatDateToHHMM(
            timeLineFinalized?.occurredAt,
          )} do dia ${formatDateToDDMMYYYY(timeLineFinalized?.occurredAt)}`
        : t("undefined");
    }
    if (currentTab !== "3" && data?.createdAt) {
      return `${formatDateToHHMM(
        data?.createdAt,
      )} do dia ${formatDateToDDMMYYYY(data?.createdAt)}`;
    }

    return t("undefined");
  };

  const handleCopy = () => {
    copyDivToClipboard("order-content");
    toast("Copiado!", {
      type: "success",
    });
  };

  return (
    <Styled.Container>
      <Styled.ContentDetails
        currentTab={currentTab === "3"}
        fullHeight={fullHeight}
      >
        <DivCopyComponent data={data} />
        <Grid container direction="column" rowGap={2}>
          {enabledPin === "true" &&
            currentTab !== "3" &&
            (data?.payment?.type === "INAPP" || data?.voucher?.valeGas) && (
              <Styled.ContainerReasonHeader onClick={openModalCode}>
                <ErrorOutlineIcon fontSize="small" color="inherit" /> Para
                finalizar esse pedido é preciso do código de entrega.
              </Styled.ContainerReasonHeader>
            )}
          <Styled.ContainerRow>
            <Typography variant="caption">ID do pedido: {data?.id}</Typography>
            <Styled.ButtonCopy onClick={handleCopy}>
              <Styled.TitleCopy>Copiar Pedido</Styled.TitleCopy>
            </Styled.ButtonCopy>
          </Styled.ContainerRow>

          <Styled.ContainerPlaceOrigin>
            <Typography variant="h6"> {data?.consumer?.name}</Typography>

            <Styled.ContentPlaceOrigin>
              {formatPlacedOrigin(data?.placedOrigin)}
            </Styled.ContentPlaceOrigin>
          </Styled.ContainerPlaceOrigin>

          <Styled.ContainerProhone>
            <Styled.TextPhone sx={{ fontSize: "15px" }} variant="caption">
              <LocalPhoneIcon
                sx={{ marginRight: "5px", marginTop: "2px" }}
                fontSize="small"
                color="inherit"
              />

              {data?.consumer?.phone && data?.consumer?.phone?.length >= 10
                ? formatPhoneByText(
                    (data?.consumer?.phone || "")
                      .replace(/[^0-9]+/g, "")
                      .replace(/^[ ]*55([\s\S]+)/, "$1"),
                  )
                : (data?.consumer?.phone || "")
                    .replace(/[^0-9]+/g, "")
                    .replace(/^[ ]*55([\s\S]+)/, "$1")}
            </Styled.TextPhone>
            {data?.placedOrigin === "ConsumerApp" &&
              currentTab !== "1" &&
              currentTab !== "3" && (
                <Styled.ButtonChat
                  onClick={() =>
                    navigate(`/orders/chat`, {
                      state: { ordersInProgress: typeOrders("InProgress") },
                    })
                  }
                >
                  {t("viewMessage")}
                </Styled.ButtonChat>
              )}
           
          </Styled.ContainerProhone>
          <Styled.ContainerFlags>
            {showGasDoPovoFlag && (
              <Styled.GasDoPovoTag>Gás do Povo</Styled.GasDoPovoTag>
            )}
            {scheduledOrder && scheduledOrderDate && (
              <Styled.ScheculedOrderCardTime>
                <SellOutlinedIcon fontSize="small" />
                <Typography variant="caption">
                  <>
                    Agendado para{" "}
                    {getSchedulingDayLabel(new Date(scheduledOrderDate))} entre{" "}
                    {formatTimeLocal(new Date(scheduledOrderDate))} e{" "}
                    {formatTimeLocal(addHours(new Date(scheduledOrderDate), 1))}
                  </>
                </Typography>
            </Styled.ScheculedOrderCardTime>
            )}
          </Styled.ContainerFlags>

          <Grid item sm={12} md={6} xs={6} xl={6}>
            <Grid container rowGap={2}>
              <Styled.ContainerAdress>
                <Grid item sm={12} md={6} xs={6} xl={6}>
                  <Styled.Grid>
                    <LocationOnIcon fontSize="small" color="inherit" />
                    <Styled.ContainerText>
                      <Typography variant="body1" textAlign="start">
                        {formatStreetAddress(data?.delivery?.address)}
                      </Typography>

                      <Typography variant="inherit" textAlign="start">
                        {data?.delivery?.address?.district}
                      </Typography>

                      <Styled.TitleMoreInfo variant="caption">
                        Informações Adicionais:
                      </Styled.TitleMoreInfo>
                      <Typography variant="inherit">
                        {data?.delivery?.remarks}
                      </Typography>
                    </Styled.ContainerText>
                  </Styled.Grid>
                </Grid>
                <Styled.ButtonMap>
                  <Styled.Link
                    href={`http://maps.google.com?q=${data?.delivery?.address?.latitude},${data?.delivery?.address?.longitude}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ABRIR MAPA
                  </Styled.Link>
                  <LaunchIcon fontSize="small" color="inherit" />
                </Styled.ButtonMap>
              </Styled.ContainerAdress>
            </Grid>
          </Grid>
          <Styled.ContainerAdress>
            <Grid item sm={12} md={6} xs={6} xl={6}>
              <Styled.ContainerHours>
                <QueryBuilderIcon fontSize="small" color="inherit" />
                <Styled.ContainerText>
                  <Typography variant="subtitle2" textAlign="start">
                    {currentTab !== "3" ? "Solicitado às " : "Finalizado às "}
                    {timeLineFunction(data)}
                  </Typography>
                </Styled.ContainerText>
              </Styled.ContainerHours>
            </Grid>
            <TimeLine dataOrder={data} currentTab={currentTab} />
          </Styled.ContainerAdress>
          <Box  mt={-1}>
            <OrderDriverSection
              key={data?.id}
              data={data}
              currentTab={currentTab}
            />
          </Box>
        </Grid>

        <Styled.ContainerProducts>
          <Typography variant="subtitle2" textAlign="start" fontWeight={400}>
            Produtos
          </Typography>
          {data?.items?.map((product) => (
            <>
              <Styled.CardProducts>
                <Styled.ContainerProductsTitle>
                  <Typography variant="subtitle2" textAlign="start">
                    {`${product.quantity} ${formatProductNameAndDescription(product.name, product.description)}`.trimEnd()}
                  </Typography>
                  <Typography variant="subtitle2" textAlign="start">
                    {formatByText.formatCurrency(Number(product.unitPrice))}
                  </Typography>
                </Styled.ContainerProductsTitle>
              </Styled.CardProducts>
            </>
          ))}

          <>
            <Styled.CardProducts>
              <Styled.ContainerProductsTitle isColor={"rgba(211,49,0,0.08)"}>
                <Styled.ContainerDiscounts>
                  <Typography variant="subtitle2" textAlign="start">
                    {t("discounts")}
                  </Typography>
                  {voucherFunction(data) && (
                    <Styled.ContainerCupom>
                      {voucherFunction(data)}
                    </Styled.ContainerCupom>
                  )}
                </Styled.ContainerDiscounts>
                <Typography variant="subtitle2" textAlign="start">
                  {formatByText.formatCurrency(
                    data?.discount ? data?.discount : "0",
                  )}
                </Typography>
              </Styled.ContainerProductsTitle>
              <Styled.ContainerProductsTitle isColor={"rgba(211,49,0,0.08)"}>
                <Styled.TitleStatus variant="subtitle2" textAlign="start">
                  {t("totalReceivable")}

                  {data?.paymentStatus === EStatusPayments.PAYED && (
                    <Styled.ContainerStatus>
                      <Typography
                        variant="h2"
                        textAlign="start"
                        color="white"
                        fontSize={15}
                      >
                        PAGO
                      </Typography>
                    </Styled.ContainerStatus>
                  )}
                </Styled.TitleStatus>
                <Typography variant="subtitle2" textAlign="start">
                  {formatByText.formatCurrency(
                    Number(
                      totalPrices(data) - (data?.discount ? data?.discount : 0),
                    ),
                  )}
                </Typography>
              </Styled.ContainerProductsTitle>
            </Styled.CardProducts>
          </>
        </Styled.ContainerProducts>

        <Styled.ContainerDocumentFiscal>
          <Typography variant="caption">CPF ou CNPJ</Typography>

          <Styled.CardProducts>
            <Styled.ContainerProductsTitle>
              <Typography variant="subtitle2" textAlign="start">
                {formatByText.cpfOrCnpjFormat(data?.fiscal?.document || "")}
              </Typography>
            </Styled.ContainerProductsTitle>
          </Styled.CardProducts>
        </Styled.ContainerDocumentFiscal>

        <Styled.ContainerFormOfPayment>
          <Typography variant="caption" textAlign="start">
            {t("FormOfPayment")}
          </Typography>
          <Typography
            variant="subtitle2"
            textAlign="start"
            sx={{
              paddingLeft: 2,
              background: "rgba(211,49,0,0.08)",
            }}
          >
            {data?.items?.length === 1 && data?.voucher?.valeGas
              ? "Vale Gás colaborador Supergasbras"
              : `
              ${data?.payment?.type ?? ""} (${
                  data?.payment.description === "Dinheiro" &&
                  data?.payment?.change > 0
                    ? `${t("money")} ${t(
                        "changeTo",
                      )} ${formatByText.formatCurrency(
                        Number(data?.payment?.change),
                      )}`
                    : data?.payment.description
                })`}
          </Typography>
        </Styled.ContainerFormOfPayment>
      </Styled.ContentDetails>
      {currentTab !== "3" && (
        <Styled.ContainerButtons>
          <Styled.ButtonRecuseOrder
            onClick={() =>
              handleOrderUpdate &&
              handleOrderUpdate(
                data?.status === "Placed" ? "deny" : "cancel",
                data?.id || "",
                data?.dealer?.id || "",
                data?.payment?.type || "",
                data?.voucher?.valeGas || false,
              )
            }
            color="inherit"
          >
            {data?.dealerState === "New"
              ? t("refuse").toUpperCase()
              : t("cancel").toUpperCase()}
          </Styled.ButtonRecuseOrder>

          <Styled.ButtonAcceptOrder
            onClick={() =>
              handleOrderUpdate &&
              handleOrderUpdate(
                data?.dealerState === "New" ? "accept" : "finalize",
                data?.id || "",
                data?.dealer?.id || "",
                data?.payment?.type || "",
                data?.voucher?.valeGas || false,
              )
            }
            color="error"
          >
            {data?.dealerState === "New"
              ? t("toAccept").toUpperCase()
              : t("finish").toUpperCase()}
          </Styled.ButtonAcceptOrder>
        </Styled.ContainerButtons>
      )}
    </Styled.Container>
  );
};

export default CardOrderDetails;
